import React, { useState } from 'react';
import { motion } from 'framer-motion';

interface ImageFadeInProps {
  src: string;
  alt: string;
  className?: string;
}

export function ImageFadeIn({ src, alt, className = '' }: ImageFadeInProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative">
      {/* Loading background */}
      <div 
        className={`absolute inset-0 bg-gray-100 rounded-3xl ${
          isLoaded ? 'opacity-0' : 'opacity-100'
        } transition-opacity duration-300`}
      />
      
      {/* Actual image */}
      <motion.img
        src={src}
        alt={alt}
        className={`${className} ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.5 }}
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
}